import { useAuth } from '../contexts/AuthContext'
import InactivityDetector from './InactivityDetector'

/**
 * Renders InactivityDetector only when the admin user is logged in.
 * Prevents the session timeout modal from showing on the login page or before auth is ready.
 */
export default function InactivityDetectorWrapper() {
  const { isAuthenticated } = useAuth()
  if (!isAuthenticated) return null
  return <InactivityDetector enabled={true} />
}
